import React from 'react';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import {Icon} from '@material-ui/core';
import {I18n} from 'react-redux-i18n';
import {get, isArray} from 'lodash';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';

import moment from '../../util/moment';

export const getClass = status => {
  switch (status) {
    case 'nonexistent':
      return 'sdcard__default';
    case 'unmounted':
      return 'sdcard__nothealthy';
    default:
      return 'sdcard__healthy';
  }
};

const SdCardStatus = props => {
  const storage = get(props, 'sdcard.storage', null);
  const metadata = get(props, 'sdcard.metadata', null);
  const alertsCheck = props.alertsCheck;

  if (storage === null) {
    return null;
  }

  const getStatus = (exist, mounted) => {
    let status = 'healthy';
    if (!exist) {
      status = 'nonexistent';
    } else if (exist && !mounted) {
      status = 'unmounted';
    }
    return status;
  };

  const getHtml = (status, count) => {
    const className = getClass(status);
    return (
      <div className="sdcard__chipcont" key={count}>
        <Chip
          id={`sdcardStatus${count}`}
          avatar={
            <Avatar className="sdcard__avatar">
              <Icon className="sdcard__icon">sd_card</Icon>
            </Avatar>
          }
          label={`${count} - ${I18n.t(`page.dvrHealth.dvr.sdcard.${status}`)}`}
          className={classnames('sdcard', className)}
        />
      </div>
    );
  };

  const handleSDCardInfoMessage = () => {
    let status = 'info';
    
    if(alertsCheck) {
      status = 'warning';
    }

    const statusClass = `sdcard__${status}-icon`;
    const lastUpdatedAt = moment(metadata.lastUpdateDate).format(I18n.t('configuration.dateTimeFormat'));
    const sdCardInfoMessage = `${I18n.t('page.dvrHealth.dvr.sdcard.lastUpdatedMessage')} ${lastUpdatedAt}`;
    return (
      <Grid
        item
        md={12}
        className="sdcard__infocont"
      >
        <Icon className={statusClass}>{status}</Icon>
        <span>{sdCardInfoMessage}</span>
      </Grid>
    );
  };

  const returnElm = [];
  if (isArray(storage.exist)) {
    // TODO: Find a way to check whether a DVR has two or four SD card slots
    // let size = find(storage.exist, it => it === true);
    // if (size < 2) size = 2;
    const size = 4;
    for (let i = 0; i < size; i++) {
      const exist = get(storage.exist, i, null);
      const mounted = get(storage.mounted, i, null);
      const status = getStatus(exist, mounted);
      returnElm.push(getHtml(status, i + 1));
    }
  } else {
    const exist = get(storage, 'exist', null);
    const mounted = get(storage, 'mounted', null);
    const status = getStatus(exist, mounted);
    returnElm.push(getHtml(status, 1));
    returnElm.push(getHtml('nonexistent', 2));
    returnElm.push(getHtml('nonexistent', 3));
    returnElm.push(getHtml('nonexistent', 4));
  }

  const showHeader = get(props, 'showHeader', true);

  return (
    <React.Fragment>
      {showHeader !== false &&
        <h4 className="sdcard__title">
          <Icon className="sdcard__title-icon">sd_card</Icon>
          {I18n.t(`page.dvrHealth.dvr.sdcard.title`)}
        </h4>
      }

      {returnElm}

      {metadata !== null && 
        <div className="sdcard__infomessage">
          {handleSDCardInfoMessage()}
        </div>
      }
    </React.Fragment>
  );
};

export default SdCardStatus;
